import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;
const BASENAME = import.meta.env.BASE_URL;
const API_DESPACHO_WEB = import.meta.env.VITE_API_DESPACHO_WEB.replace(/^\//, "");

const AttendanceSequenceService = {
    dispatchNatures: async () => axios.get(API_URL + "/nature/get/dispatchNatures").then(({ data }) => data).catch((err) => { throw err }),

    dispatchNatureGroups: async () => axios.get(API_URL + "/nature/get/dispatchNatureGroups").then(({ data }) => data).catch((err) => { throw err }),

    channelNames: async () => axios.get(API_URL + "/attendance_sequence/channelNames").then(({ data }) => data).catch((err) => { throw err }),

    streetNames: async () => axios.get(API_URL + "/street/get/streetNames").then(({ data }) => data).catch((err) => { throw err }),

    placeNames: async () => axios.get(API_URL + "/place/getPlace/placeNames").then(({ data }) => data).catch((err) => { throw err }),

    neighborhood: async () => axios.get(API_URL + "/neighborhood/get/names").then(({ data }) => data).catch((err) => { throw err }),

    allSector: async () => axios.get(API_URL + "/areaLayer/get/allSectors").then(({ data }) => data).catch((err) => { throw err }),

    apply: async (payload) => axios.post(API_URL + "/attendance_sequence/apply", payload).then(({ data }) => data).catch((err) => { throw err }),

    boHref: (occurrenceNumber) => `${BASENAME}bo/redirect/${occurrenceNumber ? occurrenceNumber.replace("/", "-") : ""}`,

    attendanceHref: (id) => `${BASENAME}${API_DESPACHO_WEB}/attendance/form/${id}`,

    dispatchHref: (id) => `${BASENAME}${API_DESPACHO_WEB}/dispatch/form/${id}`,
};

export default AttendanceSequenceService;